<!-- ======================================================================
     Operations Dashboard Shell — v2 chrome wrapper (Option C)
     Dhruvit's <app-operations-dashboard> is embedded BELOW, untouched.
     All additions here are strictly additive wrapper elements.
     ====================================================================== -->

<!-- 4px team color stripe (Operations = deep blue) -->
<div class="odsh-team-banner"></div>

<!-- ─── Greeting + Quick Actions ─────────────────────────────────────── -->
<div class="odsh-greet">
  <div class="odsh-greet__left">
    <h1 class="odsh-greet__title">
      Operations
      <span class="odsh-greet__sub">{{ greetingTime }}</span>
    </h1>
    <!-- Live counts when data lands; falls back to label-only nav links during load
         or if the section fetch fails (kpis stays null and template still reads cleanly). -->
    <div class="odsh-greet__context">
      <a class="odsh-inline" [routerLink]="['/guest-arrival-list']">
        <ng-container *ngIf="kpis"><strong>{{ fmtKpi(kpis.arrivalsToday) }}</strong> arrivals today</ng-container>
        <ng-container *ngIf="!kpis">Arrivals board</ng-container>
      </a>
      <span class="odsh-sep">·</span>
      <a class="odsh-inline" [routerLink]="['/reservation-in-out-list']" [queryParams]="{date:'today',type:'departure'}">
        <ng-container *ngIf="kpis"><strong>{{ fmtKpi(kpis.departuresToday) }}</strong> departures</ng-container>
        <ng-container *ngIf="!kpis">Departures</ng-container>
      </a>
      <span class="odsh-sep">·</span>
      <a class="odsh-inline" [routerLink]="['/maintenance-list']" [queryParams]="{status:'open'}">
        <ng-container *ngIf="kpis"><strong>{{ fmtKpi(kpis.openWorkOrders) }}</strong> open work orders</ng-container>
        <ng-container *ngIf="!kpis">Maintenance list</ng-container>
      </a>
      <span class="odsh-sep">·</span>
      <a class="odsh-inline" [routerLink]="['/housekeeping-reports']">Housekeeping</a>
    </div>
  </div>
  <div class="odsh-quick-actions">
    <a class="odsh-qa-btn" [routerLink]="['/lost-and-found']">Lost &amp; Found</a>
    <a class="odsh-qa-btn" [routerLink]="['/arrivals-board']">Arrivals Board</a>
    <a class="odsh-qa-btn odsh-qa-btn--primary" [routerLink]="['/maintenance-list']">+ Work Order</a>
  </div>
</div>

<!-- ─── KPI Action Chips strip (additive, next-step shortcuts) ─────────
     These sit just above the existing KPI tile row in Dhruvit's component.
     Each chip group mirrors one of the core KPI categories from the mockup.
     ────────────────────────────────────────────────────────────────────── -->
<div class="odsh-chips-band">
  <!-- Arrivals -->
  <div class="odsh-chip-group">
    <span class="odsh-chip-group__label">Arrivals</span>
    <a class="odsh-chip" [routerLink]="['/arrivals-board']" [queryParams]="{assignee:'me'}">Mine</a>
    <a class="odsh-chip odsh-chip--err" [routerLink]="['/arrivals-board']" [queryParams]="{status:'blocked'}">Blockers</a>
    <a class="odsh-chip odsh-chip--primary" [routerLink]="['/arrivals-board']">Open Board</a>
  </div>
  <!-- Departures -->
  <div class="odsh-chip-group">
    <span class="odsh-chip-group__label">Departures</span>
    <a class="odsh-chip odsh-chip--warn" [routerLink]="['/housekeeping-reports']" [queryParams]="{status:'pending'}">Pending HK</a>
    <a class="odsh-chip" [routerLink]="['/housekeeping-reports']">HK Reports</a>
  </div>
  <!-- Maintenance -->
  <div class="odsh-chip-group">
    <span class="odsh-chip-group__label">Maintenance</span>
    <a class="odsh-chip" [routerLink]="['/maintenance-list']" [queryParams]="{assignee:'me'}">Mine</a>
    <a class="odsh-chip odsh-chip--err" [routerLink]="['/maintenance-list']" [queryParams]="{priority:'urgent'}">Urgent</a>
    <a class="odsh-chip odsh-chip--primary" [routerLink]="['/maintenance-list']">+ New WO</a>
  </div>
  <!-- Same-day -->
  <div class="odsh-chip-group">
    <span class="odsh-chip-group__label">Turnovers</span>
    <a class="odsh-chip odsh-chip--warn" [routerLink]="['/arrivals-board']" [queryParams]="{filter:'same-day'}">Same-day</a>
    <a class="odsh-chip" [routerLink]="['/arrivals-board']">Board</a>
  </div>
</div>

<!-- ─── My Tasks band (universal) ────────────────────────────────────── -->
<div class="odsh-tasks-band">
  <div class="odsh-tasks-band__head">
    <span class="odsh-tasks-band__heading">My Tasks</span>
    <span class="odsh-tasks-band__count" *ngIf="tasksUrgent > 0 || tasksOpen > 0">
      <ng-container *ngIf="tasksUrgent > 0">{{ tasksUrgent }} urgent</ng-container>
      <ng-container *ngIf="tasksUrgent > 0 && tasksOpen > 0"> · </ng-container>
      <ng-container *ngIf="tasksOpen > 0">{{ tasksOpen }} open</ng-container>
    </span>
    <a class="odsh-tasks-band__view-all" [routerLink]="['/task-list']">View all tasks</a>
  </div>
  <div class="odsh-tasks-band__body" *ngIf="tasks.length > 0">
    <a class="odsh-task-row" *ngFor="let t of tasks" [routerLink]="['/task-edit', t.taskId]">
      <span class="odsh-task-prio" [ngClass]="taskPrioClass(t.priority)">{{ t.priority }}</span>
      <span class="odsh-task-desc">{{ t.description }}</span>
      <span class="odsh-task-due" *ngIf="t.dueDateLabel">{{ t.dueDateLabel }}</span>
    </a>
  </div>
  <div class="odsh-tasks-band__empty" *ngIf="tasks.length === 0 && !tasksLoading">
    No open tasks assigned to you
  </div>
  <div class="odsh-tasks-band__empty" *ngIf="tasksLoading">
    Loading tasks...
  </div>
</div>

<!-- ─── Dhruvit's existing dashboard (100% untouched) ────────────────── -->
<app-operations-dashboard></app-operations-dashboard>

<!-- ─── Status pills row (system health at a glance) ─────────────────── -->
<div class="odsh-status-section">
  <div class="odsh-status-label">System status</div>
  <div class="odsh-status-row">
    <a class="odsh-status-pill" [routerLink]="['/arrivals-board']">
      <span class="odsh-pill-dot odsh-pill-dot--ok"></span>
      Arrivals board
      <span class="odsh-pill-action">Open</span>
    </a>
    <a class="odsh-status-pill" [routerLink]="['/access-codes']">
      <span class="odsh-pill-dot odsh-pill-dot--ok"></span>
      Access codes
      <span class="odsh-pill-action">Manage</span>
    </a>
    <a class="odsh-status-pill" [routerLink]="['/maintenance-list']" [queryParams]="{priority:'urgent'}">
      <span class="odsh-pill-dot odsh-pill-dot--warn"></span>
      Urgent work orders
      <span class="odsh-pill-action">Review</span>
    </a>
    <a class="odsh-status-pill" [routerLink]="['/quality-test']" [queryParams]="{domain:'listings'}">
      <span class="odsh-pill-dot odsh-pill-dot--ok"></span>
      Listing quality
      <span class="odsh-pill-action">Check</span>
    </a>
  </div>
</div>

<!-- ─── Surfaced folder cards row (role-curated quick links) ─────────── -->
<div class="odsh-folders-section">
  <div class="odsh-folders-heading">Folders most used by Operations</div>
  <div class="odsh-folders-grid">

    <div class="odsh-folder-card odsh-folder-card--ops">
      <a class="odsh-folder-head" [routerLink]="['/task-list']">
        <span class="odsh-folder-ic">O</span>
        Ops
      </a>
      <div class="odsh-folder-body">
        <a class="odsh-folder-lk" [routerLink]="['/task-list']">Worklist</a>
        <a class="odsh-folder-lk" [routerLink]="['/maintenance-list']">Maintenance List</a>
        <a class="odsh-folder-lk" [routerLink]="['/activities-manager']">Activities Manager</a>
        <a class="odsh-folder-lk" [routerLink]="['/compendiums']">Compendiums</a>
        <a class="odsh-folder-lk" [routerLink]="['/composite-listings']">Composite Listings</a>
      </div>
    </div>

    <div class="odsh-folder-card odsh-folder-card--props">
      <a class="odsh-folder-head" [routerLink]="['/property-condition-list']">
        <span class="odsh-folder-ic">P</span>
        Properties
      </a>
      <div class="odsh-folder-body">
        <a class="odsh-folder-lk" [routerLink]="['/property-condition-list']">Property Condition</a>
        <a class="odsh-folder-lk" [routerLink]="['/property-features']">Property Features</a>
        <a class="odsh-folder-lk" [routerLink]="['/pictures']">Pictures</a>
        <a class="odsh-folder-lk" [routerLink]="['/access-codes']">Access Codes</a>
      </div>
    </div>

    <div class="odsh-folder-card odsh-folder-card--guests">
      <a class="odsh-folder-head" [routerLink]="['/arrivals-board']">
        <span class="odsh-folder-ic">G</span>
        Guests
      </a>
      <div class="odsh-folder-body">
        <a class="odsh-folder-lk" [routerLink]="['/guest-arrival-list']">Guest Arrival List</a>
        <a class="odsh-folder-lk" [routerLink]="['/arrivals-board']">Arrivals Board</a>
        <a class="odsh-folder-lk" [routerLink]="['/arrivals-agent']">Arrivals Agent</a>
        <a class="odsh-folder-lk" [routerLink]="['/maintenance-event']">Maintenance Event</a>
        <a class="odsh-folder-lk" [routerLink]="['/housekeeping-reports']">Housekeeping Reports</a>
        <a class="odsh-folder-lk" [routerLink]="['/lost-and-found']">Lost &amp; Found</a>
        <a class="odsh-folder-lk" [routerLink]="['/vehicle-booking']">Vehicle Booking</a>
      </div>
    </div>

  </div>
</div>
